import { FC } from 'react'
import { WidgetComponentStyled } from './styled-components'

const Support: FC = ({

}) => {
  return <WidgetComponentStyled title='Support'>
    
  </WidgetComponentStyled>
}

export default Support